// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2191":"0d3bd136f01a2618","7446":"e3390b2ae4c391d5","8151":"08e6fdcb02ec196e"}[chunkId] + ".css";
};